﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconFileInvoice } from "@tabler/icons-react";


export const catTiposFacturaIcon = IconFileInvoice;
export const catTiposFacturaHelpText = '* Aquí puede los tipos de factura.';

export class catTiposFactura extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposFactura";
        this.def.columns.c_category_id.defaultValue = "TiposFactura";
        this.Title = "Tipos de Factura";
        this.HelpText = catTiposFacturaHelpText;
        this.Icon = catTiposFacturaIcon;
    }
}